// TODO: @qmarcos revisar.
(function() {
    'use strict';

    function initSwiperLanding() {

        //
        // Moved behaviour to MpPageLanding.js
        //
        var swiperLanding = new Swiper('.js-swiper-landing', {
            slidesPerView: 'auto',
            freeMode: true,
        });
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es el carrusel principal de la home.
    function initSwiperMain() {

        // var swiperMain = new Swiper('.js-main-carousel', {
        //     effect: 'fade',
        //     pagination: {
        //         el: '.swiper-pagination',
        //         // dynamicBullets: true,
        //         clickable: true
        //     },
        // });
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es para los módulos galería de la home
    function initSwiperMiniGallery() {

        var swiperMiniGallery = new Swiper('.js-mini-gallery', {
            autoHeight: true,
            // Navigation arrows
            navigation: {
                nextEl: '.mini-gallery__nav-btn--next',
                prevEl: '.mini-gallery__nav-btn--prev',
            }
        });
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es para los módulos de la home de participaciones y notas de prensa.
    function initSwiperCardCarousel() {

        var swiperCardCarousel = new Swiper('.js-card-carousel', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
            breakpoints: {
                // when window width is >= 576
                576: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                // when window width is >= 992
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                // dynamicBullets: true,
                clickable: true
            },
        });
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es para el tablón de anuncios.
    function initSwiperBulletinEquipment() {

        var swiperBulletinEquipment = new Swiper('.js-equipment-logo-carousel', {
            slidesPerView: 'auto',
            freeMode: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            centerInsufficientSlides: true,
            spaceBetween: 40,
        });
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es para las tabs con la gráfica y el formulario de la home.
    function initSwiperHomeCTATabs() {

        // Home CTA Tabs Carousel with tab navigation
        var serviceCarousel = new Swiper('.js-chart-cta-carousel', {
            effect: 'fade',
            autoHeight: true,
            allowTouchMove: false,
            on: {
                init: function() {
                    var swiperChips = document.getElementsByClassName('js-pagination-link');

                    swiperChips[this.realIndex].classList.add('chart-cta__tab-link--selected');
                },
            },
        });

        document.addEventListener('click', function(ev) {

            // If the clicked element doesn't have the right selector, bail
            if (!ev.target.matches('.js-pagination-link')) return;

            // Don't follow the link
            ev.preventDefault();

            // Log the clicked element in the console
            // console.log(ev.target);

            serviceCarousel.slideTo(ev.target.getAttribute('data-index'));
        }, false);

        serviceCarousel.on('slideChange', function() {
            var swiperChipActive = document.getElementsByClassName('chart-cta__tab-link--selected'),
                swiperChips = document.getElementsByClassName('js-pagination-link');

            swiperChipActive[0].classList.remove('chart-cta__tab-link--selected');
            swiperChips[this.realIndex].classList.add('chart-cta__tab-link--selected');
        });
        // .end - Post Detail Tabs Carousel with button navigation
    }

    // TODO: @qmarcos mover inicialización donde corresponda. Es tanto para equipamientos como para directorios.
    function initSwiperPostDetailTabs() {

        // Post Detail Tabs Carousel with button navigation
        var serviceCarousel = new Swiper('.js-post-detail-tabs-carousel', {
            effect: 'fade',
            autoHeight: true,
            allowTouchMove: false,
            on: {
                init: function() {
                    var swiperChips = document.getElementsByClassName('js-pagination-link');

                    swiperChips[this.realIndex].classList.add('post-detail__tabs-carousel-pagination-link--active');
                },
            },
        });

        document.addEventListener('click', function(ev) {

            // If the clicked element doesn't have the right selector, bail
            if (!ev.target.matches('.js-pagination-link')) return;

            // Don't follow the link
            ev.preventDefault();

            // Log the clicked element in the console
            // console.log(ev.target);

            serviceCarousel.slideTo(ev.target.getAttribute('data-index'));
        }, false);

        serviceCarousel.on('slideChange', function() {
            var swiperChipActive = document.getElementsByClassName('post-detail__tabs-carousel-pagination-link--active'),
                swiperChips = document.getElementsByClassName('js-pagination-link');

            swiperChipActive[0].classList.remove('post-detail__tabs-carousel-pagination-link--active');
            swiperChips[this.realIndex].classList.add('post-detail__tabs-carousel-pagination-link--active');
        });
        // .end - Post Detail Tabs Carousel with button navigation
    }

    function initSwiper() {

        // Service carousel with button navigation
        var serviceCarousel = new Swiper('.js-service-carousel', {
            effect: 'fade',
            // slidesPerView: 'auto',
            // spaceBetween: 10,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            },
            on: {
                init: function() {
                    var swiperChips = document.getElementsByClassName('js-pagination-link');

                    swiperChips[this.realIndex].classList.add('service-carousel__pagination-link--active');
                },
            },
        });

        document.addEventListener('click', function(ev) {

            // If the clicked element doesn't have the right selector, bail
            if (!ev.target.matches('.js-pagination-link')) return;

            // Don't follow the link
            ev.preventDefault();

            // Log the clicked element in the console
            // console.log(ev.target);

            serviceCarousel.slideTo(ev.target.getAttribute('data-index'));
        }, false);

        serviceCarousel.on('slideChange', function() {
            var swiperChipActive = document.getElementsByClassName('service-carousel__pagination-link--active'),
                swiperChips = document.getElementsByClassName('js-pagination-link');

            swiperChipActive[0].classList.remove('service-carousel__pagination-link--active');
            swiperChips[this.realIndex].classList.add('service-carousel__pagination-link--active');
        });
        // .end - Service carousel with button navigation


        // DEMO carousel initializations
        // TODO: @qmarcos @andres borrar
        var swiperMulti = new Swiper('.js-swiper-multi', {
            // some swiper options/callbacks
            // slidesPerView: 'auto',
            slidesPerView: 2.5,
            slidesPerGroup: 2.5,
            // loop: true,
            spaceBetween: 24,
            slidesOffsetBefore: 10,
            slidesOffsetAfter: 10,
            freeMode: true,
            // freeModeSticky: true,
            centerInsufficientSlides: true,
            // Responsive breakpoints
            breakpointsInverse: true,
            breakpoints: {
                // when window width is >= 320px
                600: {
                    slidesPerView: 3.5,
                    slidesPerGroup: 3.5,
                },
                768: {
                    slidesPerView: 4.5,
                    slidesPerGroup: 4.5,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                992: {
                    slidesPerView: 5.5,
                    slidesPerGroup: 5.5,
                },
                1200: {
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                // 1600: {
                //     slidesOffsetBefore: 0,
                //     slidesOffsetAfter: 0,
                // }
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            },

            // // Optional parameters
            // direction: 'vertical',
            // loop: true,

            // // If we need pagination
            // pagination: {
            //     el: '.swiper-pagination',
            // },

            // // Navigation arrows
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },

            // // And if we need scrollbar
            // scrollbar: {
            //     el: '.swiper-scrollbar',
            // },
        });

        var swiperBoxed = new Swiper('.js-swiper-boxed', {
            // slidesPerView: 'auto',
            // Navigation arrows
            navigation: {
                nextEl: '.carousel__btn-next',
                prevEl: '.carousel__btn-prev',
            },
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            },
        });

        var swiperFull = new Swiper('.js-swiper-full', {
            slidesPerView: 1.1,
            freeMode: true,
            // freeModeSticky: true,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            },
        });

        var swiperBgImg = new Swiper('.js-swiper-bg-img', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            },
        });
        // .end - DEMO carousel initializations
    }

    function init() {
        // initSwiper();
        // initSwiperPostDetailTabs();
        // initSwiperBulletinEquipment();
        // initSwiperMain();
        // initSwiperMiniGallery();
        // initSwiperCardCarousel();
        // initSwiperHomeCTATabs();
    }

    init();
})();